/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./task-form.vue?vue&type=template&id=cdcae30e&"
import script from "./task-form.vue?vue&type=script&lang=js&"
export * from "./task-form.vue?vue&type=script&lang=js&"
import style0 from "./task-form.vue?vue&type=style&index=0&id=cdcae30e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports